<template>
  <div id="app">
    <iframe class="windows" :src="url"></iframe>
  </div>
</template>

<script>

export default {
  name: 'app',
  components: {
   
  },
  data() {
    return {
      url:''
    }
  },
  created() {
     if (/Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent)) {
        this.url = '/web/index.html'
      } else {
        this.url = '/pc/index.html'
      }
  },
}
</script>

<style>
body{
  overflow: hidden;
}
.windows{
  width: 100%;
  height: 100vh;
}
.layui-layer{
    background-color: transparent !important;
    box-shadow: none !important;
}
.el-message{
  position: fixed !important;
  top: 50% !important;
  left: 50% !important;
}
  /*按钮主题色  */
  .btn_hover{
    cursor: pointer;
    transition: all 0.5s;
  }
  .btn_hover:hover{
    transition: all 0.5s;
    filter: brightness(1.2);
  }
  .btn_color_down{
    background: #BF4949;
    transition: all 0.5s;
  }
  .btn_color_down:hover{
    transition: all 0.5s;
    filter: brightness(1.2);
  }
  .btn_color {
    transition: all 0.5s;
    background: #AC8747;
  }
  .btn_color:hover {
    transition: all 0.5s;
    filter: brightness(1.2);
  }
  /* 全局配置message */
  .el-message{
    z-index: 9999999999 !important;
  }
  input{
    outline-style: none;
  }
  input:focus{
    border:1px solid #AC8747 !important;
  }
  label{
    cursor: pointer;
  }
  .flex_box{
    display: flex;
    justify-content: center;
    align-items: center;
  }
  a{
    cursor: pointer;
  }
  .lang_one{
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .lang_point {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 1;
      overflow: hidden;
      text-overflow: ellipsis;
      word-break: break-all;
  }
  .text_ellipsis {
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      -o-text-overflow: ellipsis;
  }

</style>
